import {
  DrillDownMenuItem,
  UseDrillDownMenu,
} from "@/components/root/drilldown-menu/drilldown-menu.state";
import { ICONS } from "../icons.map";
import { InvestigateSingleEntity } from "../menu-items";
import { POPULATION_TYPE } from "../models";
import { EventBusListenerArgs } from "./model";
import { SharedState } from "../state";
export const bus_file_row_menu_listener = (): EventBusListenerArgs => [
  "showFileMenu",
  async (p: {
    item: { name: string; id: string; clusterUID: string };
    event: MouseEvent;
  }) => {
    const menu: DrillDownMenuItem[] = [
      InvestigateSingleEntity(ICONS.ENTITIES.get(POPULATION_TYPE.FILE))(
        p.item.name
      ),
    ];

    const res = await UseDrillDownMenu().show({
      menu,
      event: p.event,
    });

    if (res.didUserSelectedAnAction) {
      SharedState.investigation.investigate({
        type: POPULATION_TYPE.FILE,
        id: p.item.id,
        name: p.item.name,
        cluster_id: p.item.clusterUID,
      });
    }
  },
];
